module.exports = __webpack_public_path__ + "assets/views/00_common/cookie_btn_outline_ru.png";